let currentId = 0;

const shortid = {
  generate: function () {
    return currentId++;
  }
};

export default shortid;
